module.exports = __webpack_public_path__ + "static/media/f_eyeshape_round_brown.1550a858.png";